/* eslint-disable no-unused-expressions */
import { useEffect, useRef } from 'react';
var createRootElement = function (id) {
    var _a;
    var rootContainer = (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.createElement('div');
    rootContainer === null || rootContainer === void 0 ? void 0 : rootContainer.setAttribute('id', id);
    return rootContainer;
};
var addRootElement = function (rootElement) {
    var _a, _b;
    (_b = (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.appendChild(rootElement);
};
var usePortal = function (id) {
    var rootElementRef = useRef();
    var setupElement = function () {
        var _a;
        var existingParent = (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.querySelector("#".concat(id));
        var parentElement = existingParent || createRootElement(id);
        if (!existingParent) {
            addRootElement(parentElement);
        }
        if (rootElementRef.current) {
            parentElement === null || parentElement === void 0 ? void 0 : parentElement.appendChild(rootElementRef.current);
        }
        return function () {
            var _a;
            (_a = rootElementRef.current) === null || _a === void 0 ? void 0 : _a.remove();
            if (!parentElement.childElementCount) {
                parentElement === null || parentElement === void 0 ? void 0 : parentElement.remove();
            }
        };
    };
    var getRootElement = function () {
        var _a;
        if (!rootElementRef.current) {
            rootElementRef.current = (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.createElement('div');
        }
        return rootElementRef.current;
    };
    useEffect(setupElement, [id]);
    return getRootElement();
};
export { usePortal };
//# sourceMappingURL=usePortal.js.map